import $ from "jquery";

if ( !icn_cookie_notice.has_consent( "complete" ) ) {
	$( ".content-block__video > .no-cookie" ).css( "display", "flex" );
} else {
	const iframe = $( ".content-block__video > .youtube-video" );
	const src = iframe.attr( "data-src" );
	$( this ).parent().empty().append( iframe.attr( { "src": src } ) );
}